export const createFontStack = (font: string) => `${font}, sans-serif`;
